// ----------------------------------------------------------------------

export default function Dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    boxShadow: theme.customShadows.dialog,
                    borderRadius: theme.shape.card,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    // MUI drops the top padding of content that follows a
                    // title, which cut off the floating label of the first
                    // field (Update profile). Every dialog gets room for it.
                    '.MuiDialogTitle-root + &': {
                        paddingTop: theme.spacing(1.5),
                    },
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    // The same footer in every dialog, whether or not the
                    // dialog padded it itself.
                    padding: theme.spacing(2, 3),
                    gap: theme.spacing(1),
                    '& > :not(:first-of-type)': {
                        marginLeft: 0,
                    },
                },
            },
        },
    };
}
